import http from '@/http'

const PATH = '/customers/metrics'

export default {
    /**
     * @param {{customer_ids: number[], [period]: string}} data
     * @returns {Promise<void>}
     */
    async recalculateMetrics (data) {
        try {
            const response = await http.put(PATH, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
